
// CSS
import "../Page/Page.css"
import "./QuoteComp.css"

// React
import React from "react";


interface imageObj{
     width?: string | number;
    text: string;
    isQuote?: boolean;
}

const QuoteComp: React.FC<imageObj> = ({ width, text, isQuote = false}) => {
    return (
        <div className="quoteContainer">
          <div className="quoteBackground">
            <text className="quote">
              {isQuote ? `"${text}"` : text}
            </text>
          </div>
        </div>
    );
};

export default QuoteComp;



